import React from 'react';
import Sorting from '../../views/Sorting';
import '../../css/regokas.css';
import _ from 'lodash';
import Loader from '../../components/loader';
import SearchBar from '../../views/SearchBar';
import Style from 'style-it';
import { ToastContainer} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { connect } from 'react-redux';
import {
    Table,
    TableContainer,
    TableHead,
    TableRow,
    TableCell,
    TableBody,
    Paper,
} from "@mui/material";
import * as ActionTypes from '../../actions/types';
import { AiOutlinePlus } from 'react-icons/ai';
import { IoIosArrowDown, IoIosArrowUp } from 'react-icons/io';
import { Box } from '@mui/system';



class OkasInventory extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            okasInventoryData: [],
            okasBoxDatalocation: [],
            siData: [],
            kk: 'asdvhj',
            okasBox_type: '',
            okasBox_serialNo: '',
            okasBox_version: '',
            user: '',
            created_at: '',
            modified: '',
            selectedBoxes: [],
            selectedSi: '',
            si_id: '',
            okasBox_id: [],
            error: '',
            nameerror: '',
            namess: '',
            sortedType: '',
            searchValue: '',
            actualdata: [],
            disabledvalue: '',
            successmsgmodaldata: localStorage.getItem('dataadded'),
            showmodels: '',
            showmodels1: '',
            loader: '',
            passwordi: false,
            currentPage: 1,
            todosPerPage: 10,
            statuson: false, statustw: false, statusth: false,
            statusfo: false, statusfi: false, statussi: false,
            statusse: false, statusei: false, statusni: false,
            statuste: false,
            disableAddButton: false,
            confirmWindow: false,
            projectManagerToDelete: '',
            pagemode: ''

        };
        this.handleClickpage = this.handleClickpage.bind(this);
    }

    crosserrorfullmsg = () => {
        localStorage.removeItem('dataadded');
        this.setState({
            error: '',
        })

    }

    componentWillMount() {
    }

    errormsg = () => {
        setTimeout(
            function () {
                localStorage.removeItem('dataadded');
                this.setState({
                    successmsgmodaldata: '',
                    error: '',
                })
            }
                .bind(this), 3000
        );
    }

    crosssuccessfullmsg = () => {
        localStorage.removeItem('dataadded');
        this.setState({
            successmsgmodaldata: '',
        })
    }

    componentDidMount() {
        this.getallrealdata();
    }

    getallrealdata = () => {
        this.setState({
            loader: true,
        })
        let TokenValue = 'Token ' + localStorage.getItem("auth");
        var headers = {
            'Content-Type': 'application/json',
            'Authorization': TokenValue,
            'X-CSRFToken': localStorage.getItem('csrftoken')
        }
        fetch('/we/we/okasunassigneddata', {
            method: "GET",
            headers: headers
        })
            .then(response => response.json())
            .then(okasInventoryData => {
                this.setState({
                    okasInventoryData,
                    actualdata: okasInventoryData
                }, () => {
                    this.renderTableData();
                })
                this.setState({
                    loader: false,
                })
            })

        fetch('/we/we/addSI/', {
            method: "GET",
            headers: headers
        })
            .then(response => response.json())
            .then(siData => {
                this.setState({
                    siData,
                    actualdata: siData
                }, () => {
                    this.renderTableData();
                })
                this.setState({
                    loader: false,
                })
            })

    }



    renderTableDatalocation = (type) => {
        if (type === 'location') {
            var typee = 0;
            let xx = this.state.okasBoxDatalocation.map((e, index) => {
                typee = typee + 1;
                return (
                    <option key={index} value={e.ID}>{e.location}</option>
                )
            });
            return xx;
        }
    }

    renderLocation = () => {
        let LocationData = [];
        if (Array.isArray(this.state.okasBoxDatalocation)) {
            this.state.okasBoxDatalocation.forEach((e) => {
                LocationData.push({
                    label: e.location,
                    value: e.ID.toString()
                });
            });
            this.setState({
                LocationData: LocationData
            });
        } else {
            return null;
        }
    }


    handleClickpage(event, position) {
        let pageNo = 0;
        if (position === 'position') {
            pageNo = event
        } else {
            pageNo = event.target.id
        }
        this.setState({
            currentPage: Number(pageNo)
        });
        this.renderTableData('type1');
        this.renderTableData('pagination');
    }

    handleCheckboxChange = (boxId) => {
        const { selectedBoxes } = this.state;
        const index = selectedBoxes.indexOf(boxId);

        if (index === -1) {
            this.setState((prevState) => ({
                selectedBoxes: [...prevState.selectedBoxes, boxId],
                okasBox_id: [...prevState.okasBox_id, boxId],
            }));
        } else {
            const updatedSelectedBoxes = [...selectedBoxes];
            updatedSelectedBoxes.splice(index, 1);

            this.setState({
                selectedBoxes: updatedSelectedBoxes,
                okasBox_id: updatedSelectedBoxes,
            });
        }
    };

    handleRadioSiChange = (siId) => {
        this.setState({
            selectedSi: siId,
            si_id: siId,
        });
    };

    renderTableData = (type) => {
        if (this.state.okasInventoryData.detail == 'Invalid token.') {
            localStorage.removeItem('auth');
            localStorage.removeItem('username');
            this.props.history.push('/login')
        }

        let indexOfLastTodo = this.state.currentPage * this.state.todosPerPage;
        let indexOfFirstTodo = indexOfLastTodo - this.state.todosPerPage;
        let currentTodos = this.state.okasInventoryData.slice(indexOfFirstTodo, indexOfLastTodo);
        let currentSi = this.state.siData.si_data;


        if (type === 'pagination') {
            let pageNumbers = [];
            for (let i = 1; i <= Math.ceil(this.state.okasInventoryData.length / this.state.todosPerPage); i++) {
                pageNumbers.push(i);
            }
            let renderPageNumbers = pageNumbers.map((number, i) => {
                if ((this.state.currentPage - 3 < i + 1) && ((this.state.currentPage + 3 > i + 1 || 6 > i + 1))) {
                    return (
                        <li className={this.state.currentPage == number ? "active" : null}><a id={number} onClick={this.handleClickpage}>{number}</a></li>
                    );
                }
            });
            return renderPageNumbers;
        }

        if (type === 'type1') {
            var typee = 0;
            let xx = currentTodos.map((e, index) => {
                const dateFromString = new Date(e.modified);
                const dateOnly = dateFromString.toISOString().split('T')[0];
                typee = typee + 1;
                return (
                    <tr key={index}>
                        <td className={this.props.windowWidth > 835 ? "qwerty" : ""}>
                            <input
                                type="checkbox"
                                name={e.okasBox_type}
                                onChange={() => this.handleCheckboxChange(e.okasBox_id)}
                                disabled={e.user !== "unassigned"}
                                checked={this.state.selectedBoxes.includes(e.okasBox_id)}
                            />
                        </td>
                        <td style={{textAlign:'center'}} className={this.props.windowWidth > 760 ? "qwerty" : ""}>{(this.state.currentPage * this.state.todosPerPage) - this.state.todosPerPage + index + 1}</td>
                        <td>{e.okasBox_type === "VOD Box" ? "Media Studio" :
                            e.okasBox_type === "UVOD Box" ? "Ultra Media Studio" :
                                e.okasBox_type === "Audio Box" ? "Music Studio" : e.okasBox_type}</td>
                        <td >{e.okasBox_serialNo}</td>
                        <td>{e.okasBox_version}</td>
                        <td>{e.user === "unassigned" ? <span style={{ color: "red" }}>UNASSIGNED</span> : <span style={{ color: "green" }}>ASSIGNED</span>}</td>
                        <td>{dateOnly}</td>
                    </tr>
                )
            });
            return xx;
        }

        if (type === 'siSelect') {
            var typee = 0;
            let xx = currentSi.map((e, index) => {
                typee = typee + 1;
                return (
                    <tr key={index}>
                        <td className="config-table">{e.si_name}</td>
                        <td className="config-table">{e.si_area}</td>
                        <td className="config-table">{e.si_mobile}</td>
                        <td className="config-table">{e.si_email}</td>
                        <td className="config-table">
                            <input
                                type="radio"
                                name={e.si_name}
                                checked={this.state.selectedSi === e.si_id}
                                onChange={() => this.handleRadioSiChange(e.si_id)}
                            />
                        </td>
                    </tr>
                )
            });
            return xx;
        }
    }



    onopenmodel = (event) => {
        this.props.backgroundScrollStop(!this.props.redux.globalVar.backgroundScrollStop);

        this.setState({
            showmodels: 'true',
            pagemode: ''
        });
        const selectedBoxIds = this.state.selectedBoxes.join(', ');
        const totalSelected = this.state.selectedBoxes.length;
        const modalTitle = selectedBoxIds
            ? `Assign ${totalSelected} Box${totalSelected > 1 ? 'es' : ''} to`
            : 'Assign Box';
        this.setState({
            modalTitle: modalTitle,
        });
        this.props.searchBarActivate(false)
    }

    onclosemodel = (event) => {
        this.setState({
            showmodels: '',
        })
    }

    onAssignSiClosemodel = (event) => {
        this.props.backgroundScrollStop(!this.props.redux.globalVar.backgroundScrollStop);
        this.setState({
            showmodels: '',
            si_id: '',
            okasBox_id: [],
            disableAddButton: false,
            selectedBoxes: [],
            selectedSi: '',
        })
    }


    onAddClickHandler = (buttonaction) => {

        let TokenValue = 'Token ' + localStorage.getItem("auth");
        var headers = {
            'Content-Type': 'application/json',
            'Authorization': TokenValue,
            'X-CSRFToken': localStorage.getItem('csrftoken'),
        }

        const { si_id, okasBox_id } = this.state;

        let tt = {
            si_id: si_id,
            okasBox_id: okasBox_id,
        };

        if (si_id && okasBox_id) {
            this.setState({ disabledvalue: 'disabled' });
            this.setState({ loader: true });

            fetch('/we/we/assignSI/ ', {
                method: "POST",
                headers: headers,
                body: JSON.stringify(tt)
            })
                .then(response => response.json())
                .then(data => {
                    if (data.message === "Success" && buttonaction === 'add') {
                        this.setState({
                            successmsgmodaldata: 'dataadded',
                            successmodalstates: 'add',
                            disabledvalue: '',
                        });
                        this.getallrealdata();
                        alert('Box Successfully Assign To System Integrator!');
                        this.onAssignSiClosemodel();
                        this.errormsg();

                    } else {
                        this.setState({ disabledvalue: '' });
                        this.setState({ loader: false });
                        alert("Unable To Assign System Integrator")
                        return null;

                    }
                    this.setState({
                        loader: false,
                    });
                })
        }
    }


    restoreData = (data) => {
        this.setState({
            okasInventoryData: data,
        })
    }


    sortingFunc = (type, searchValue) => {


        if (type !== "search") {
            this.props.searchBarActivate(false)
        }

        if (type == "okasBox_type") {
            this.setState({
                statuson: false, statustw: false, statusth: false,
                statusfo: false, statusfi: false, statussi: false,
                statusse: false, statusei: false, statusni: false,
                statuste: false,
                statuson: !this.state.statuson,
            })
        }
        if (type == "okasBox_serialNo") {
            this.setState({
                statuson: false, statustw: false, statusth: false,
                statusfo: false, statusfi: false, statussi: false,
                statusse: false, statusei: false, statusni: false,
                statuste: false,
                statuson: !this.state.statuson,
            })
        }
        if (type == "okasBox_version") {
            this.setState({
                statuson: false, statustw: false, statusth: false,
                statusfo: false, statusfi: false, statussi: false,
                statusse: false, statusei: false, statusni: false,
                statuste: false,
                statustw: !this.state.statustw,
            })
        }
        if (type == "user") {
            this.setState({
                statuson: false, statustw: false, statusth: false,
                statusfo: false, statusfi: false, statussi: false,
                statusse: false, statusei: false, statusni: false,
                statuste: false,
                statusth: !this.state.statusth,
            })
        }
        if (type == "modified") {
            this.setState({
                statuson: false, statustw: false, statusth: false,
                statusfo: false, statusfi: false, statussi: false,
                statusse: false, statusei: false, statusni: false,
                statuste: false,
                statusth: !this.state.statusth,
            })
        }


        if (this.state.sortedType !== type && type !== 'search') {
            this.setState({
                sortedType: type
            })
            Sorting(this.restoreData, type, this.state.okasInventoryData);
        } else if (type === 'search') {
            type = 'search';
            Sorting(this.restoreData, type, this.state.actualdata, searchValue);
        } else {
            type = 'reverse';
            Sorting(this.restoreData, type, this.state.okasInventoryData);
        }
    }



    onSelectChange = (operationMode, valueSelect) => {
        if (valueSelect.label !== undefined) {
            this.setState({
                [operationMode]: valueSelect.value,
                error: false,
                locationerror: false,
            })

        }
    }


    render() {
        return Style.it(`
        @media only screen and (max-width: 760px){
      td:nth-of-type(1):before { content: ""; }
      td:nth-of-type(2):before { content: "S.NO"; }
      td:nth-of-type(3):before { content: "TYPE"; }
      td:nth-of-type(4):before { content: "SERIAL NO."; }
      td:nth-of-type(5):before { content: "VERSION"; }
      td:nth-of-type(6):before { content: "STATUS"; }
      td:nth-of-type(7):before { content: "DATE OF PURCHASE"; }

      td.config-table:nth-of-type(1):before { content: "System Integrator Name"; }
      td.config-table:nth-of-type(2):before { content: "Area"; }
      td.config-table:nth-of-type(3):before { content: "Mobile No"; }
      td.config-table:nth-of-type(4):before { content: "Email"; }
      td.config-table:nth-of-type(5):before { content: " "; }
    }`, <div>
            <ToastContainer />
            <div className="selfcontainer"
                style={{
                    position: !this.props.redux.globalVar.backgroundScrollStop && this.props.windowWidth < 760 ? "fixed" : "absolute",
                    overflow: !this.props.redux.globalVar.backgroundScrollStop && this.props.windowWidth < 760 ? "hidden" : "",

                }}

            >
                <ToastContainer />
                {this.state.loader ? <Loader /> : null}

                {this.props.redux.globalVar.searchBarShow ?
                    <div className='row searchinput'>
                        <SearchBar
                            autoFocus
                            value={this.state.searchValue}
                            onChange={(e) => {
                                this.setState({
                                    searchValue: e
                                }, () => {
                                    this.sortingFunc('search', this.state.searchValue)
                                })
                            }
                            }
                            onRequestSearch={() => this.sortingFunc('search', this.state.searchValue)}
                            resetSearch={(e) => {
                                this.setState({
                                    searchValue: e
                                }, () => {
                                    this.sortingFunc('search', '')
                                })
                            }}
                        />
                    </div>
                    : ''}

                {this.state.showmodels ?
                    <div className="selfmodal fade" id="mastercontrollerbox" role="dialog" aria-hidden="true" data-backdrop="static" data-keyboard="false">
                        <div className="selfmodal-dialog"
                            style={{
                                width: this.props.windowWidth > 825 ? "50%" : "95%",

                            }}
                        >
                            <div className="selfmodal-content" style={{ marginTop: "100px", width: '70%', margin: 'auto' }}>
                                <div className="modal-header"  >
                                    <button type="submit" className="close" data-dismiss="modal"
                                        onClick={this.onAssignSiClosemodel.bind(this)}
                                    >&times;</button>
                                    <h3 className="modal-title">{this.state.modalTitle} </h3>
                                </div>
                                <div className="modal-body" >
                                    <TableContainer
                                        component={Paper}
                                        className={this.props.windowWidth > 760 ? "tablecontent" : "mobile-device-margin-zero"}
                                        id="example"
                                    >
                                         <Table className={"tablecontent"}>
                                            <TableHead>
                                                <TableRow>
                                                    <TableCell sx={{ color: "white", fontSize: '11px' }}>SI Name</TableCell>
                                                    <TableCell sx={{ color: "white", fontSize: '11px' }}>Area</TableCell>
                                                    <TableCell sx={{ color: "white", fontSize: '11px' }}>Mobile No.</TableCell>
                                                    <TableCell sx={{ color: "white", fontSize: '11px' }}>Email</TableCell>
                                                    <TableCell />
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>{this.renderTableData("siSelect")}</TableBody>
                                        </Table>
                                    </TableContainer>
                                </div>
                                <br/>
                                <div className="modal-footer">
                                    <React.Fragment>
                                        <button type="button"
                                            onClick={this.onAssignSiClosemodel.bind(this)}
                                            className="btn allbtn" data-dismiss="modal">
                                            Cancel
                                        </button>
                                        <button type="submit" disabled={this.state.disabledvalue ? this.state.disabledvalue : null}
                                            onClick={this.onAddClickHandler.bind(this, 'add')}
                                            className="btn allbtn" style={{ backgroundColor: '#4286f5' }} data-dismiss="modal">
                                            Add
                                        </button>
                                    </React.Fragment>
                                </div>
                            </div>
                        </div>
                    </div>

                    : null}

                <div className="addregOkasButton" >
                    {this.state.selectedBoxes.length > 0 && (
                        <Box
                            component="a"
                            href="#myModal"
                            className="addregOkasButtonicon button-custom-height-size"
                            onClick={this.onopenmodel.bind(this)}
                            sx={{
                                display: "flex",
                                alignItems: "center",
                                backgroundColor: "#f9f9f9",
                                color: "#94979a",
                                textTransform: "none",
                                padding: "10px 20px",
                            }}
                        >
                            <AiOutlinePlus size={30} style={{ marginRight: 8, color: "#15599F" }} />
                            <span className="hidden-xs hidden-sm button-color">Assign To System Integrator</span>
                        </Box>
                    )}
                </div>

                <div className="row">
                    <h3 className="sentence-case">{this.props.redux.globalVar.reUserNameStyle}'s OKAS Inventory</h3>
                    <h6 className="mb-3 mt-0">Find the comprehensive view and details of all the boxes in your inventory.</h6>
                    <div className="tests" onContextMenu={(e) => { e.preventDefault(); }}>
                        <TableContainer component={Paper} className={this.props.windowWidth > 760 ? "table table-striped tablecontent" : "mobile-device-margin-zero"} id="example">
                            <Table className={"tablecontent"}>
                                <TableHead>
                                    <TableRow>
                                        <TableCell></TableCell>
                                        <TableCell style={{ paddingRight: "24px", width: this.props.windowWidth > 835 ? "6%" : "7%", color: 'white', fontSize: '11px', textAlign:'center' }}>S.No</TableCell>
                                        <TableCell style={{ width: this.props.windowWidth > 835 ? "20%" : "20%", color: 'white', fontSize: '11px' }}>
                                            TYPE
                                            {this.state?.statuson ? (
                                                <IoIosArrowUp size={16} className="pull-right" onClick={() => this.sortingFunc("okasBox_type", "")} />
                                            ) : (
                                                <IoIosArrowDown size={16} className="pull-right" onClick={() => this.sortingFunc("okasBox_type", "")} />
                                            )}
                                        </TableCell>
                                        <TableCell style={{ width: this.props.windowWidth > 835 ? "15%" : "15%", color: 'white', fontSize: '11px' }}>
                                            SERIAL NO.
                                            {this.state?.statustw ? (
                                                <IoIosArrowUp size={16} className="pull-right" onClick={() => this.sortingFunc("okasBox_serialNo", "")} />
                                            ) : (
                                                <IoIosArrowDown size={16} className="pull-right" onClick={() => this.sortingFunc("okasBox_serialNo", "")} />
                                            )}
                                        </TableCell>
                                        <TableCell style={{ width: this.props.windowWidth > 835 ? "20%" : "15%", color: 'white', fontSize: '11px' }}>
                                            VERSION
                                            {this.state?.statusth ? (
                                                <IoIosArrowUp size={16} className="pull-right" onClick={() => this.sortingFunc("okasBox_version", "")} />
                                            ) : (
                                                <IoIosArrowDown size={16} className="pull-right" onClick={() => this.sortingFunc("okasBox_version", "")} />
                                            )}
                                        </TableCell>
                                        <TableCell style={{ width: this.props.windowWidth > 835 ? "15%" : "15%", color: 'white', fontSize: '11px' }}>
                                            STATUS
                                            {this.state?.statusfo ? (
                                                <IoIosArrowUp size={16} className="pull-right" onClick={() => this.sortingFunc("user", "")} />
                                            ) : (
                                                <IoIosArrowDown size={16} className="pull-right" onClick={() => this.sortingFunc("user", "")} />
                                            )}
                                        </TableCell>
                                        <TableCell style={{ width: this.props.windowWidth > 835 ? "18%" : "23%", color: 'white', fontSize: '11px' }}>
                                            DATE OF PURCHASE
                                            {this.state?.statusfi ? (
                                                <IoIosArrowUp size={16} className="pull-right" onClick={() => this.sortingFunc("modified", "")} />
                                            ) : (
                                                <IoIosArrowDown size={16} className="pull-right" onClick={() => this.sortingFunc("modified", "")} />
                                            )}
                                        </TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {this.renderTableData("type1")}
                                </TableBody>
                            </Table>
                        </TableContainer>
                        <div className="pull-right">
                            {this.state.todosPerPage < this.state.okasInventoryData.length ?
                                <ul className="pagination pull-right paginat">

                                    <li>
                                        <span className="">Showing {(this.state.currentPage * this.state.todosPerPage) - this.state.todosPerPage + 1} -{this.state.currentPage * this.state.todosPerPage - this.state.okasInventoryData.length < 0 ? this.state.currentPage * this.state.todosPerPage : this.state.okasInventoryData.length}  of {this.state.okasInventoryData.length} enteries</span>
                                    </li>

                                    <li>
                                        <a
                                            style={{ pointerEvents: this.state.currentPage === 1 ? 'none' : '' }}
                                            onClick={this.state.currentPage == -1 + this.state.currentPage * this.state.todosPerPage ? null :
                                                this.handleClickpage.bind(this, this.state.currentPage - 1, 'position')
                                            }
                                            aria-label="Previous">
                                            <span aria-hidden="true">&laquo;</span>
                                            <span className="sr-only">Previous</span>
                                        </a>
                                    </li>

                                    {this.renderTableData('pagination')}
                                    <li className="">
                                        <a className=""
                                            style={{ pointerEvents: Math.ceil(this.state.okasInventoryData.length / this.state.todosPerPage) === Number(this.state.currentPage) ? 'none' : '' }}
                                            onClick={this.state.currentPage * this.state.todosPerPage == this.state.okasInventoryData.length ? null :
                                                this.handleClickpage.bind(this, this.state.currentPage + 1, 'position')
                                            }

                                            aria-label="Next">
                                            <span aria-hidden="true">&raquo;</span>
                                            <span className="sr-only">Next</span>
                                        </a>
                                    </li>
                                </ul>
                                : null}
                        </div>

                    </div> </div>

            </div>
        </div>
        );
    }

}

const mapStateToProps = state => {
    return {
        redux: state,
    };
};


const mapDispatchToProps = dispatch => {
    return {
        searchBarActivate: (data) => dispatch({ type: ActionTypes.SEARCHBAR, data: data }),
        searchBarStyleActivate: (data) => dispatch({ type: ActionTypes.SEARCHBARSTYLE, data: data }),
        backgroundScrollStop: (data) => dispatch({ type: ActionTypes.SCROLLSTOP, data: data }),

    };
};


export default connect(mapStateToProps, mapDispatchToProps)(OkasInventory); 